import { useEffect } from 'react'
import {
  PROMO_STICKY_FOOTER_FACE_STACK_FLAG_NAME,
  useIsPen7676Eligible,
} from '@mc/promos'
import { trackExperimentViewed } from '@mc/track-event'
import useSticky, { type StickyConfig } from 'components/Sticky/useSticky'
import {
  STICKY_FOOTER_TYPES,
  type StickyFooterType,
} from 'components/StickyFooter/useTrackStickyFooterViewed'

export const useTrackPen7676Experiment = (
  stickyFooterType: StickyFooterType,
  stickyConfig?: StickyConfig,
) => {
  const isPromoFooter = stickyFooterType === STICKY_FOOTER_TYPES.PROMOTION
  const stickyIsActive = useSticky(stickyConfig)
  const isEligible = useIsPen7676Eligible()

  useEffect(() => {
    if (stickyIsActive && isPromoFooter && isEligible) {
      trackExperimentViewed(PROMO_STICKY_FOOTER_FACE_STACK_FLAG_NAME)
    }
  }, [stickyIsActive, isPromoFooter, isEligible])
}
